import { useEffect, useState, useRef } from 'react'
import { useImmer } from 'use-immer'
import { produce } from 'immer';
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { Divider, Button } from 'antd'
import UMCButton from '../common/UMCButton'
import { DARK_GRAY } from "../../styles/styleUtils"
import InputField from "./InputField"
import TabExtraContent from '../common/TabExtraContent'
import CustomDialog from './CustomDialog'
import getData from './GetData'
import PrefixComponent from './PrefixComponent'

//===============================
// Prefix parameters config page
//===============================

const PrefixParameters = ({ onPrevious, onNext, activeProfile, trunkConfig, setTrunkConfig, configurationData, setConfigurationData }) => {
    const [errorsOnPage, setErrorsOnPage] = useState(0);

    const [workingSipTrunkConfig, setWorkingSipTrunkConfig] = useImmer(trunkConfig);
    
    // Prefix array of child component. This is kept in a separate file to manage easily the item add/remove
    // and to be able to manage the create button
    const [prefixes, setPrefixes] = useImmer(trunkConfig?.Profile?.UI_Prefix?.UMC_Calling_Number); 

    const [prefixPathReplacement, setPrefixPathReplacement] = useState(false);

    // Dialog parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState();
    const [footer, setFooter] = useState([]);

    const creationAllowed = useRef(false); // Used to check if path replacement value can be created

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);
    var ccproductid = getSessionItem(CC_PRODUCT_ID);
    var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

    let nextStep = false;
    let errorsOnRedraw = errorsOnPage;

    useEffect(() => {
        if (activeProfile.type === "Visual AA") {
            dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_SIP_TRUNK") + " : " + activeProfile.name));
        } else {
            dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_TRUNK") + " : " + activeProfile.name));

        }
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    useEffect(() => {
        // If something was configured for path replacement use that value else ask if it has to be defined
        if (trunkConfig?.Profile?.UI_Prefix?.UMC_Prefix_Path_Replacement?.Local_Number === "") {
            checkConfiguredPathReplacement();
        }
        else {
            if (trunkConfig?.Profile?.UI_Prefix?.UMC_Prefix_Path_Replacement !== undefined)
                setPrefixPathReplacement(true);
        }
    },[]);

    useEffect(() => {
        errorHandler((prefixes?.length > 0) ? false : true);
    }, [prefixes]);

    // SIP Trunk data handlers
    const updateLocalNumber = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_Prefix.UMC_Prefix_Path_Replacement.Local_Number = value; });
    }

    const updatePrefixes = (value) => {
        if (workingSipTrunkConfig?.Profile?.UI_Prefix?.UMC_Calling_Number)
            return produce(workingSipTrunkConfig, draft => { draft.Profile.UI_Prefix.UMC_Calling_Number = value; });
    };

    // Error handler (count errors on the page)
    const errorHandler = (value) => {
        if (value === true) {
            errorsOnRedraw++;
        }
        else {
            if (errorsOnPage > 0)
                errorsOnRedraw--;
        }
        setErrorsOnPage(errorsOnRedraw);
    }


    const removePrefixPathReplacement = () => {
        setWorkingSipTrunkConfig(draft => {
            delete draft.Profile.UI_Prefix.UMC_Prefix_Path_Replacement;
        });
    };

    // Handlers
    const prereqHandler = (data) => {
        if (data[0]?.isExisting !== undefined) {
            setPrefixPathReplacement(!(data[0].isExisting));
            if (data[0].isExisting === true)
            {
                // Remove directly Path replacement
                removePrefixPathReplacement();
            }
        }
    }

    const creationHandler = (data) => {
        creationAllowed.current = data[0]?.creationPossible;
    }

    // Verify if prefix path replacement has to be entered
    const checkConfiguredPathReplacement = async () => {
        var url, response;

        try {
            url = SIP_URL + "/check-prefix-pathreplacement/" + nodeNumber + "/" + ccproductid;

            dispatch(setContentLoading(true));
            response = await getData(url, null, prereqHandler);
            dispatch(setContentLoading(false));
        }
        catch (e) {
            console.error(e);
            dispatch(setContentLoading(false));
        }
    }

    // Check if prefix path replacement can be created
    const checkCreationConfiguredPathReplacement = async () => {
        var url, response;

        try {
            url = SIP_URL + "/check-prefix-pathreplacement-creation/" + nodeNumber + "/" + ccproductid + "/" + 
                workingSipTrunkConfig?.Profile?.UI_Prefix?.UMC_Prefix_Path_Replacement?.Local_Number;

            dispatch(setContentLoading(true));
            response = await getData(url, null, creationHandler);
            dispatch(setContentLoading(false));
        }
        catch (e) {
            console.error(e);
            dispatch(setContentLoading(false));
        }
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);

        // Change page
        if (nextStep)
            onNext();
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        nextStep = false; // Avoid to continue if cancel has been hit  
    };

    // Validation handler for the page
    async function validateFields() {
        let updatedConfig;

        // Update the prefixes array in the working buffer
        updatedConfig = updatePrefixes(prefixes);

        // Update the parent state
        setTrunkConfig(updatedConfig);

        if (prefixPathReplacement) {
            await checkCreationConfiguredPathReplacement();

            if (creationAllowed.current === false) {
                setDlgType("Error");
                setTitle(getTranslated(dict, "LABEL_SIP_TRUNK_CREATION_IMPOSSIBLE"));   
                setMessage(getTranslated(dict, "MSG_PATH_REPLACEMENT_CANNOT_BE_CREATED"));
                setFooter([
                    <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
                        {getTranslated(dict, "LABEL_OK")}
                    </Button>,
                ]);
                showModal(true);
            }
            else {
                // It is allowed to create the path replacement
                onNext();
            }
        }
        else {
            onNext();
        }
    }

    // Go back in the wizard, but save the values in case the user goes forward again
    const onBack = () => {
        let updatedConfig;

        // Update the prefixes array in the working buffer
        updatedConfig = updatePrefixes(prefixes);

        // Update the parent state
        setTrunkConfig(updatedConfig);

        // The go back
        onPrevious();
    }

    // Top right icons 
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={activeProfile.docRef ? ["document", "help"] : ["help"]}
            documentButtonText={activeProfile.docRef}
            handleDocument={() => {
                if (activeProfile.docUrl !== "")
                    window.open(`${activeProfile.docUrl}`, "_blank")
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-VAA__fig_ezc_tfj_1gc`, "_blank")
            }}
        />
    }

    return (<>
        {
            prefixPathReplacement && (() => {
                if (configurationData?.Profile?.UI_Prefix?.UMC_Prefix_Path_Replacement !== undefined) {
                    return (<div>
                        <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                            {getTranslated(dict, "LABEL_UI_SIP_TRUNK_DATA")}
                        </Divider>

                        { // Prefix path replacement
                            <InputField label={getTranslated(dict, "PARAM_PREFIX_PATH_REPLACEMENT")}
                                defaultValue={configurationData?.Profile?.UI_Prefix?.UMC_Prefix_Path_Replacement?.Local_Number?.defaultValue}
                                regexp={configurationData?.Profile?.UI_Prefix?.UMC_Prefix_Path_Replacement?.Local_Number?.pattern}
                                handleChange={updateLocalNumber}
                                handleError={errorHandler}
                                value={trunkConfig?.Profile?.UI_Prefix?.UMC_Prefix_Path_Replacement?.Local_Number} />
                        }

                    </div>)
                }
            })()
        }

        {(() => {
            if (configurationData?.Profile?.UI_Prefix?.UMC_Calling_Number !== undefined) {
                return (<div className="profile-span">
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_PREFIX_PLAN")}
                    </Divider>

                    <PrefixComponent  
                        numberPattern={configurationData?.Profile?.UI_Prefix?.UMC_Calling_Number[0]?.Local_Number?.pattern} 
                        digitsPattern={configurationData?.Profile?.UI_Prefix?.UMC_Calling_Number[0]?.Number_Of_Digit?.pattern}
                        prefixes={prefixes} 
                        setPrefixes={setPrefixes} />
                    </div>)
            }
        })()
        }

        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onBack}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_CREATE")}
                type="primary"
                onClick={validateFields}
                disabled={errorsOnPage !== 0} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "500px"}
            footer={footer}
            type={dlgType}
            onCancel={handleCancel}
        >
            {message}
        </CustomDialog>
    </>);
}

export default PrefixParameters;